import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";
import { LoadingCircular } from "../../../ui/LoadingCircular";
import { BusinessModuleUIRenderer } from "../../modules/BusinessModuleUIRenderer";
import type { BusinessPlanSection } from "../BusinessPlanModel";

type BusinessPlanSectionModuleUIProps = {
  businessPlanUid: string;
  section: BusinessPlanSection;
  businessModuleUid: string;
};

export const BusinessPlanSectionModuleUI = observer(
  ({ businessModuleUid }: BusinessPlanSectionModuleUIProps) => {
    const { businessModulesApi } = useApi();
    const { businessModulesStore } = useStores();

    // Load  module
    React.useEffect(() => {
      return businessModulesApi.watchItem(businessModuleUid);
    }, [businessModulesApi, businessModuleUid]);

    const businessModule = businessModulesStore.byId.get(businessModuleUid);

    if (!businessModule) {
      return <LoadingCircular />;
    }

    return <BusinessModuleUIRenderer uid={businessModuleUid} />;
  },
);
